export default {
  callingAPI: false,
  searching: '',
  serverURI: '',
  user: null,
  token: null,
  tempToken: null,
  userInfo: {
    messages: [{1: 'test', 2: 'test'}],
    notifications: [],
    tasks: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js